import { useMemo } from "react";

import { AgChartPanel, AgGridPanel, buildAgOptions, useIsDark } from "@/components/cinch/charts";

import { resultToDataset, type PanelVizSpec, type QueryResultLike } from "../viz";

/**
 * Pure renderer for a panel: a query result + a viz spec → an AG chart (or an
 * AG Grid when `mode` is "table" / the spec has no chartable series). No
 * controls — the {@link PanelEditor} owns the viz state; a saved panel card
 * passes its stored viz.
 */
export function PanelChart({
  result,
  viz,
  mode = "chart",
  className,
  onDatumClick,
}: {
  result: QueryResultLike;
  viz: PanelVizSpec;
  mode?: "chart" | "table";
  className?: string;
  /** Wired to a chart point click when the panel has a drill-down. */
  onDatumClick?: (datum: Record<string, unknown>) => void;
}) {
  const isDark = useIsDark();
  const dataset = useMemo(() => resultToDataset(result, viz), [result, viz]);

  if (mode === "table" || !dataset || dataset.series.length === 0) {
    return (
      <AgGridPanel columns={viz.columns ?? result.columns} rows={result.rows} className={className} />
    );
  }
  return (
    <AgChartPanel
      options={buildAgOptions(dataset, viz.chartType ?? dataset.chartTypes[0] ?? "bar", isDark)}
      className={className}
      onSeriesNodeClick={onDatumClick}
    />
  );
}
